const copyPasteRequestStr = {
  toastr: 'Recorte efetuado',
  toastr1: 'Recorte efetuado com sucesso'
};

export default copyPasteRequestStr;
